import React from 'react';

import './ModalWindow.sass';

const ModalWindow = ({close, children}) => {
  return (
    <div className="modal" onClick={(e) => {
      if(e.target.classList.contains('modal')) close();
    }}>
      {children}
    </div>
  );
};

export default ModalWindow;